export default __webpack_public_path__ + "static/RunRight10-9697ac9466775d7a2e9ff3b19ad7c4c6.mp3";